export default {"src":"/_next/static/media/Starter-badge.8fd1c3c8.svg","height":68,"width":68};